import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-filaments',
  templateUrl: './filaments.component.html',
  styleUrls: ['./filaments.component.css']
})
export class FilamentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
